<div class="px-3 pt-6 pb-8">
  <p class="font-medium text-2xl">Загрузите банковскую выписку из вашего личного кабинета</p>

  <div class="flex flex-wrap justify-content-center align-items-center gap-5 mt-5">
    <button
      pButton
      type="button"
      class="p-button-warning p-button-lg"
      style="min-width: 150px !important; max-width: 150px !important"
      (click)="selectBank.emit(BankEnum.TINKOFF)">
      <div
        class="flex align-items-center gap-2"
        style="margin-left: 2px">
        <img
          alt="tinkoff"
          src="assets/images/tinkoff.png"
          style="height: 1.5rem" />
        <span class="font-bold">Тинкькофф</span>
      </div>
    </button>

    <button
      pButton
      type="button"
      class="p-button-success p-button-lg"
      style="min-width: 150px !important; max-width: 150px !important"
      (click)="selectBank.emit(BankEnum.SBERBANK)">
      <div
        class="flex align-items-center gap-2"
        style="margin-left: 9px">
        <img
          alt="sber"
          src="assets/images/sber.png"
          style="height: 1.5rem" />
        <span class="font-bold">СберБанк</span>
      </div>
    </button>

    <button
      pButton
      type="button"
      class="p-button-danger p-button-lg"
      style="min-width: 150px !important; max-width: 150px !important"
      (click)="selectBank.emit(BankEnum.ALFA)">
      <div
        class="flex align-items-center gap-2"
        style="margin-left: 2px">
        <img
          alt="alfa"
          src="assets/images/alfa.png"
          style="height: 1.5rem" />
        <span class="font-bold">Альфа Банк</span>
      </div>
    </button>
  </div>
</div>
